import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { intlMessage } from 'constants/propTypes';

import Message from 'components/Message';

const HomeModuleLink = ({ message, to, onClick }) => (
  <h4 className="text--right mb-l">
    <Link to={to} className="dashboard__module__link__tag" onClick={onClick}>
      <Message message={message} />
      <i className="dashboard__module__arrow--right" />
    </Link>
  </h4>
);

HomeModuleLink.propTypes = {
  message: intlMessage,
  to: PropTypes.string,
  onClick: PropTypes.func,
};

export default HomeModuleLink;
